import React from "react";

import useProgressiveImg from "../../Hooks/useProgressiveImg";

const CustomImg = ({
  origSrc = "",
  tempSrc = "",
  className = "",
  fetchPriority = "",
  lazyLoad = true,
  setImgfetchStatus
}) => {
  const [src, { blur }] = useProgressiveImg(
    tempSrc,
    origSrc,
    fetchPriority,
    setImgfetchStatus
  );
  const showImage = !(blur && !tempSrc);

  return showImage ? (
    <img
      loading={blur ? "eager" : lazyLoad ? "lazy" : "eager"}
      // eslint-disable-next-line react/no-unknown-property
      fetchPriority={blur ? "auto" : fetchPriority || "auto"}
      alt=""
      src={src}
      className={className}
      // style={{
      // width: 200,
      // filter: blur ? "blur(20px)" : "none",
      // transition: blur ? "none" : "all 0.3s ease-out",
      // }}
    />
  ) : null;
};

export default CustomImg;
